module.exports = __webpack_public_path__ + "../resources/images/focusedOthersImage-8a5a7856c4c6b20083663fc9f5d0889c.svg";